import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Angulartics2 } from 'angulartics2';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'FunBible';
  shouldShowGdprNotification: boolean;
  private routerSubscription: Subscription;
  @ViewChild('contentContainer') contentContainerEl: ElementRef;

  constructor(
      angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
      angulartics2: Angulartics2,
      private router: Router,
      private cookieService: CookieService
  ) {
    angulartics2GoogleAnalytics.startTracking();
    angulartics2.setUserProperties.next({
      version: '1.0'
    });

    this.routerSubscription = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.contentContainerEl.nativeElement.scrollTop = 0;
        }
      });

    if (this.cookieService.get('gdpr') !== 'ok') {
      setTimeout( () => {
        this.shouldShowGdprNotification = true;
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
